package horcrux.frontend.common.views.components.loading

import horcrux.frontend.common.BooleanState
import mui.material.ButtonVariant
import react.FC
import react.PropsWithChildren

external interface LoadingButtonProps : PropsWithChildren {
    var id: String
    var variantMaybe: ButtonVariant?
    var onClick: (BooleanState) -> Unit
}

val LoadingButton = FC<LoadingButtonProps> { props ->
    val isLoadingState = BooleanState()
    mui.lab.LoadingButton {
        +props.children
        this.id = props.id
        this.variant = props.variantMaybe
        this.loading = isLoadingState.get()
        this.onClick = { props.onClick(isLoadingState) }
    }
}
